import React from "react";
import Box from "@material-ui/core/Box";
import { useDebounce } from "use-debounce";
import { useQuery } from "@apollo/client";
import {
  CONSULTA_CATEGORIAS_VENTA,
  CONSULTA_PRODUCTOS_VENTAS,
} from "../../../gql/Ventas/ventas_generales";
import { VentasContext } from "../../../context/Ventas/ventasContext";
import {
  calculatePrices2,
  findProductArray,
  verifiPrising,
} from "../../../config/reuserFunctions";
import { MainContext } from "../../../context/MainCtx";
import ListaProductos from "./ListaProductos/ListaProductos";
import BuscarProducto from "./BuscarProducto";
import CategoriasSearch from "./Categorias";
import { Grid } from "@material-ui/core";
import PaginationProductos from "./ListaProductos/Pagination";
import AgregarProductoVenta from "../../ventas/InputsVentasGen.js/AgregarProducto";

const inital_state_filtros = { producto: "", cat: "", timer: 500 };

const ProductosVentaRapida = () => {
  const sesion = JSON.parse(localStorage.getItem("sesionCafi"));
  let datosVentas = JSON.parse(localStorage.getItem("DatosVentas"));
  const {
    updateTablaVentas,
    setUpdateTablaVentas,
    setDatosVentasActual,
    openBuscarProducto,
    setOpenBuscarProducto,
    reloadProductos,
    priceSelected,
  } = React.useContext(VentasContext);
  const { snackMessage } = React.useContext(MainContext);
  const [searchProducto, setSearchProducto] = React.useState(
    inital_state_filtros
  );
  const [productoSeleccionado, setProductoSeleccionado] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const limit = 20;
  const inputProductos = React.useRef(null);
  const { cat, producto } = searchProducto;
  const timer = (cat && !producto) || (!cat && !producto) ? 0 : 500;
  const [value] = useDebounce(searchProducto, timer);

  const queryCats = useQuery(CONSULTA_CATEGORIAS_VENTA, {
    variables: {
      empresa: sesion.empresa._id,
      sucursal: sesion.sucursal._id,
    },
  });

  const { data, refetch, loading, error } = useQuery(
    CONSULTA_PRODUCTOS_VENTAS,
    {
      variables: {
        empresa: sesion.empresa._id,
        sucursal: sesion.sucursal._id,
        input: {
          producto: value.producto ? value.producto : "",
          cat: value.cat ? value.cat : "",
        },
        limit,
        offset: page,
      },
    }
  );

  let productosBusqueda = null;

  if (data) productosBusqueda = data.obtenerProductosVentas;

  const obtenerDatos = (name, value) => {
    setSearchProducto({ ...searchProducto, [name]: value });
  };

  const cleanFiltros = (e) => {
    setSearchProducto(inital_state_filtros);
  };

  const handleClickOpen = () => {
    setProductoSeleccionado([]);
    //productosBusqueda = [];
    setOpenBuscarProducto(!openBuscarProducto);
    setSearchProducto(inital_state_filtros);
  };

  React.useEffect(() => {
    window.addEventListener("keydown", KeyDownFunction);
    function KeyDownFunction(e) {
      if (e.altKey && e.keyCode === 80) {
        handleClickOpen();
      }
    }
    return () => window.removeEventListener("keydown", KeyDownFunction);
  }, [openBuscarProducto]);

  React.useEffect(() => {
    cleanFiltros();
    refetch({
      variables: {
        empresa: sesion.empresa._id,
        sucursal: sesion.sucursal._id,
        input: {
          producto: "",
          cat: "",
        },
        limit,
        offset: 0,
      },
    });
  }, [reloadProductos]);

  React.useMemo(() => {
    setPage(0);
  }, [value]);

  const agregarProductos = async (producto, value = 1) => {
    let unidad = producto.unidad.toUpperCase();
    if (!producto.id_producto.withoutInventory) {
      let productoVenta = null;
      const inventario = producto.inventario_general[0];
      if (datosVentas && datosVentas.productos.length > 0) {
        const prod = datosVentas.productos.filter(
          (res) => res._id === producto._id
        );
        if (prod.length > 0) productoVenta = prod[0];
      }
      //console.log({cantidad: producto.cantidad, inventario: producto.inventario_general[0]});
      //console.log(productoVenta);
      if (producto.concepto === "medidas") {
        //cantidad solo en Pz
        if (!productoVenta) {
          if (value > producto.cantidad) {
            snackMessage({
              message: "No hay existencias",
              variant: "info",
            });
            return;
          }
        } else {
          if (productoVenta.cantidad_venta + value > producto.cantidad) {
            snackMessage({
              message: "No hay existencias",
              variant: "info",
            });
            return;
          }
        }
      } else {
        //inventario_general
        if (unidad === "CAJA" || unidad === "COSTAL") {
          //valida existencia en productoAlmacen
          if (!productoVenta) {
            if (value > inventario.cantidad_existente_maxima) {
              snackMessage({
                message: "No hay existencias",
                variant: "info",
              });
              return;
            }
          } else {
            if (
              productoVenta.cantidad_venta + value >
              inventario.cantidad_existente_maxima
            ) {
              snackMessage({
                message: "No hay existencias",
                variant: "info",
              });
              return;
            }
          }
        } else if (unidad === "PZ" || unidad === "LT" || unidad === "KG") {
          //valida existencia en productoAlmacen
          if (!productoVenta) {
            if (value > inventario.cantidad_existente) {
              snackMessage({
                message: "No hay existencias",
                variant: "info",
              });
              return;
            }
          } else {
            if (
              productoVenta.cantidad_venta + value >
              inventario.cantidad_existente
            ) {
              snackMessage({
                message: "No hay existencias",
                variant: "info",
              });
              return;
            }
          }
        }
      }
    }

    let granel_base = {
      granel: false,
      valor: 0,
    };
    if (unidad === "KG" || unidad === "COSTAL") {
      granel_base = {
        granel: true,
        valor: value,
      };
    }

    let venta = JSON.parse(localStorage.getItem("DatosVentas"));
    let productosVentas = venta === null ? [] : venta.productos;
    let venta_actual = venta === null ? [] : venta;
    let venta_existente =
      venta === null
        ? {
            subTotal: 0,
            total: 0,
            impuestos: 0,
            iva: 0,
            ieps: 0,
            descuento: 0,
            monedero: 0,
          }
        : venta;

    let productosVentasTemp = productosVentas;

    let CalculosData = {
      subTotal: 0,
      total: 0,
      impuestos: 0,
      iva: 0,
      ieps: 0,
      descuento: 0,
      monedero: 0,
    };

    const producto_encontrado = await findProductArray(producto);

    if (!producto_encontrado.found && producto._id) {
      if (value === -1) return;
      const newP = { ...producto };
      //Tomar el precio con descuento o normal
      let productoPrecioFinal = newP.descuento_activo
        ? newP.descuento.precio_neto
        : newP.precio_unidad.precio_neto;

      let new_prices = await calculatePrices2({
        newP,
        cantidad: 0,
        granel: granel_base,
        origen: "Ventas1",
        precio_boolean: false,
      });

      //vericiar si se eligio uno de los 6 precios
      const { precios_producto } = producto.id_producto.precios;

      if (priceSelected > 1) {
        const price_found = precios_producto.filter(
          ({ precio_neto, numero_precio }) =>
            priceSelected === numero_precio && precio_neto > 0
        );
        if (price_found.length) {
          productoPrecioFinal = price_found[0].precio_neto;
          newP.precio = price_found[0].precio_neto;
          newP.precio_a_vender = price_found[0].precio_neto;
          newP.precio_actual_producto = price_found[0].precio_neto;
          newP.precio_actual_object = price_found[0];
          new_prices = await calculatePrices2({
            newP,
            cantidad: 0,
            granel: granel_base,
            origen: "Tabla",
            precio_boolean: true,
            precio: price_found[0],
          });
        }
      }

      new_prices.newP.precio_anterior = productoPrecioFinal;

      new_prices.newP.iva_total_producto = parseFloat(new_prices.ivaCalculo);
      new_prices.newP.ieps_total_producto = parseFloat(new_prices.iepsCalculo);
      new_prices.newP.impuestos_total_producto = parseFloat(
        new_prices.impuestoCalculo
      );
      new_prices.newP.subtotal_total_producto = parseFloat(
        new_prices.subtotalCalculo
      );
      new_prices.newP.total_total_producto = parseFloat(
        new_prices.totalCalculo
      );

      //agregar producto al inicio del arreglo
      productosVentasTemp.splice(0, 0, new_prices.newP);

      CalculosData = {
        subTotal:
          parseFloat(venta_existente.subTotal) +
          parseFloat(new_prices.subtotalCalculo),
        total:
          parseFloat(venta_existente.total) +
          parseFloat(new_prices.totalCalculo),
        impuestos:
          parseFloat(venta_existente.impuestos) +
          parseFloat(new_prices.impuestoCalculo),
        iva:
          parseFloat(venta_existente.iva) + parseFloat(new_prices.ivaCalculo),
        ieps:
          parseFloat(venta_existente.ieps) + parseFloat(new_prices.iepsCalculo),
        descuento:
          parseFloat(venta_existente.descuento) +
          parseFloat(new_prices.descuentoCalculo),
        monedero:
          parseFloat(venta_existente.monedero) +
          parseFloat(new_prices.monederoCalculo),
      };
    } else if (producto_encontrado.found && producto._id) {
      const {
        cantidad_venta,
        ...newP
      } = producto_encontrado.producto_found.producto;

      let new_cant = cantidad_venta + value;

      newP.cantidad_venta = parseFloat(new_cant);
      const verify_prising = await verifiPrising(newP);
      const newPrising = verify_prising.found
        ? verify_prising.object_prising
        : newP.precio_actual_object;

      const new_resta = await calculatePrices2({
        newP,
        cantidad: newP.granel_producto.granel ? value : cantidad_venta,
        precio_boolean: true,
        precio: newP.precio_actual_object,
        granel: newP.granel_producto,
        origen: "Tabla",
      });

      if (newP.granel_producto.granel) {
        newP.granel_producto = {
          granel: true,
          valor: parseFloat(new_cant),
        };
      }

      const new_suma = await calculatePrices2({
        newP,
        cantidad: newP.granel_producto.granel ? value : parseFloat(new_cant),
        precio_boolean: true,
        precio: newPrising,
        granel: newP.granel_producto,
        origen: "Tabla",
      });

      newP.iva_total_producto = parseFloat(new_suma.ivaCalculo);
      newP.ieps_total_producto = parseFloat(new_suma.iepsCalculo);
      newP.impuestos_total_producto = parseFloat(new_suma.impuestoCalculo);
      newP.subtotal_total_producto = parseFloat(new_suma.subtotalCalculo);
      newP.total_total_producto = parseFloat(new_suma.totalCalculo);

      if (verify_prising.found) {
        newP.precio_a_vender = new_suma.totalCalculo;
        newP.precio_anterior = newP.precio_actual_porducto;
        newP.precio_actual_producto = verify_prising.pricing;
        newP.precio_actual_object = verify_prising.object_prising;

        newP.precio_actual_object = {
          cantidad_unidad: verify_prising.object_prising.cantidad_unidad
            ? verify_prising.object_prising.cantidad_unidad
            : null,
          numero_precio: verify_prising.object_prising.numero_precio
            ? verify_prising.object_prising.numero_precio
            : null,
          unidad_maxima: verify_prising.object_prising.unidad_maxima
            ? verify_prising.object_prising.unidad_maxima
            : null,
          precio_general: verify_prising.object_prising.precio_general
            ? verify_prising.object_prising.precio_general
            : null,
          precio_neto: verify_prising.object_prising.precio_neto
            ? verify_prising.object_prising.precio_neto
            : null,
          precio_venta: verify_prising.object_prising.precio_venta
            ? verify_prising.object_prising.precio_venta
            : null,
          iva_precio: verify_prising.object_prising.iva_precio
            ? verify_prising.object_prising.iva_precio
            : null,
          ieps_precio: verify_prising.object_prising.ieps_precio
            ? verify_prising.object_prising.ieps_precio
            : null,
          utilidad: verify_prising.object_prising.utilidad
            ? verify_prising.object_prising.utilidad
            : null,
          porciento: verify_prising.object_prising.porciento
            ? verify_prising.object_prising.porciento
            : null,
          dinero_descontado: verify_prising.object_prising.dinero_descontado
            ? verify_prising.object_prising.dinero_descontado
            : null,
        };
      } else {
        newP.cantidad_venta = parseFloat(new_cant);
        newP.precio_anterior = newP.precio_actual_producto;
        newP.precio_a_vender = new_suma.totalCalculo;
      }

      productosVentasTemp.splice(
        producto_encontrado.producto_found.index,
        1,
        newP
      );

      if (newP.cantidad_venta === 0) return;

      CalculosData = {
        subTotal:
          parseFloat(venta_existente.subTotal) -
          parseFloat(new_resta.subtotalCalculo) +
          new_suma.subtotalCalculo,
        total:
          parseFloat(venta_existente.total) -
          parseFloat(new_resta.totalCalculo) +
          new_suma.totalCalculo,
        impuestos:
          parseFloat(venta_existente.impuestos) -
          parseFloat(new_resta.impuestoCalculo) +
          new_suma.impuestoCalculo,
        iva:
          parseFloat(venta_existente.iva) -
          parseFloat(new_resta.ivaCalculo) +
          new_suma.ivaCalculo,
        ieps:
          parseFloat(venta_existente.ieps) -
          parseFloat(new_resta.iepsCalculo) +
          new_suma.iepsCalculo,
        descuento:
          parseFloat(venta_existente.descuento) -
          parseFloat(new_resta.descuentoCalculo) +
          new_suma.descuentoCalculo,
        monedero:
          parseFloat(venta_existente.monedero) -
          parseFloat(new_resta.monederoCalculo) +
          new_suma.monederoCalculo,
      };
    }

    CalculosData.subtotal_base = CalculosData.subTotal;
    CalculosData.total_base = CalculosData.total;

    localStorage.setItem(
      "DatosVentas",
      JSON.stringify({
        ...CalculosData,
        cliente:
          venta_actual.venta_cliente === true ? venta_actual.cliente : {},
        venta_cliente:
          venta_actual.venta_cliente === true
            ? venta_actual.venta_cliente
            : false,
        productos: productosVentasTemp,
        tipo_emision: venta_actual.tipo_emision
          ? venta_actual.tipo_emision
          : "TICKET",
      })
    );
    setDatosVentasActual({
      ...CalculosData,
    });
    setUpdateTablaVentas(!updateTablaVentas);
    /* handleClickOpen(); */
    inputProductos?.current?.focus();
  };

  return (
    <Box width="100%">
      <Box display="flex" gridGap={10}>
        <AgregarProductoVenta fullwidth />
        <BuscarProducto
          searchProducto={searchProducto}
          obtenerDatos={obtenerDatos}
          inputProductos={inputProductos}
          cleanFiltros={cleanFiltros}
          error={error}
        />
      </Box>
      <Grid container>
        <Grid item md={10}>
          <CategoriasSearch
            searchProducto={searchProducto}
            obtenerDatos={obtenerDatos}
            queryCats={queryCats}
            error={error}
          />
        </Grid>
        <Grid item md={2}>
          <PaginationProductos
            productosBusqueda={productosBusqueda}
            loading={loading}
            page={page}
            setPage={setPage}
            limit={limit}
            error={error}
          />
        </Grid>
      </Grid>
      <ListaProductos
        productosBusqueda={productosBusqueda}
        productoSeleccionado={productoSeleccionado}
        setProductoSeleccionado={setProductoSeleccionado}
        loading={loading}
        agregarProductos={agregarProductos}
        error={error}
      />
    </Box>
  );
};

export default ProductosVentaRapida;
